<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("cardtype") }}</div>
      <router-link class="btn-blue" to="add-card-type">{{
        $t("add")
      }}</router-link>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="filterIsActive => getCardList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{$tc('viewing')}}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container mr-2">
            <label
              :class="
                selected.bank && selected.bank.length > 0
                  ? 'shift-up'
                  : 'd-none'
              "
              >{{ $t('select') }} {{ $t("bank") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.bank" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(bank,bankIndex) in banks"
                  :key="bankIndex"
                  @click="onSelectHandler('bank',bank)"
                  name="bank"
                  id="bank"
                >{{ bank.bank_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="banks"
                :searchable="true"
                :placeholder="
                  selected.bank && selected.bank.length > 0
                    ? selected.bank
                    :  $t('selectBank')
                "
                label="bank_name"
                track-by="bank_id"
                @select="onSelectHandler('bank', $event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$t('enterbankname')" />
            </div>
            <p class="error_message">
              <!-- <span v-if="submitted && selected.bank.length == 0">{{$t('bankmsg')}}</span> -->
            </p>
          </div>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'card_type'"
                @click="onSortValue('card_type', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('card_type', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('card_type', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("cardtype") }}
            </th>
            <th class="pl-2">{{ $t("bank") }}</th>

            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="cardname && cardname.length > 0">
          <tr v-for="(card, cardIndex) in cardname" :key="cardIndex">
            <td>{{ card.card_type }}</td>
            <td>{{ card.bank_name }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="card.card_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    card.card_is_active === 'Y'
                      ? 'active'
                      : card.card_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item v-on:click="onEditCard(card)">
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewCard(card)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td style="text-align: center" colspan="3">
              <!-- <span>No Records Found.</span> -->
              <NoRecords/>
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination
        v-if="cardname.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      card_id: "",
      card_type: "",
      bank_id: "",
      bank_name: "",
      cardname: [],

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ],
      banks: [],
      selected: {
        bank: ""
      },

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: ""
    };
  },
  beforeMount() {
    // this.getCardList();
    this.getBankList();
    // this.onViewOffer();
    // this.onEditInstitute();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      if (this.selected.bank.length == 0) {
        return this.$toasted.show("Please select Bank");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getCardList();
    },
    getBankList: function() {
      // this.banks = [];
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          // console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function(type, value) {
      if (type == "bank") {
        this.bank_id = value.bank_id;
        this.selected.bank = value.bank_name;
        this.getCardList();
      }
    },
    getCardList: function(filterIsActive = "Y") {
      this.cardname = [];
      MarketingService.getAllCardType(
        this.perPage,
        this.currentPage,
        this.bank_id,
        this.columnName,
        this.orderBy,
        filterIsActive
      ).then(response => {
        // console.log("response :", response);
        const { data } = response;

        // console.log("data.Records :", data.Records);
        if (data && data.Records.length > 0) {
          this.cardname = data.Records;
          // console.log("this.offername :", this.offername);
          this.rows = data.totalCount;
          if (this.rows <= this.selectedvalue) {
            // this.selectedvalue = this.rows;
          }
        }
      });
    },
    onViewCard: function(card) {
      this.$router.push({
        path: "/marketing/view-card-type",
        query: { card_id: card.card_id }
      });
      // console.log("institute_id ++++++++ :", offer);
    },
    onEditCard: function(card) {
      this.$router.push({
        path: "/marketing/edit-card-type",
        query: { card_id: card.card_id }
      });
      // console.log("bank_id :", bank.bank_id);
    },

    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCardList();
      } else {
        this.currentPage = event;
        this.getCardList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CardTypeComponents/cardType.vue